import { AxiosInstance } from 'axios'
import { PageInfo, PaginationOpt } from '../model'
import { deserialize } from 'ts-jackson'
import { wrapApiCall } from '@/lib/axios'
import {
  CreateUpSellPayload,
  UpdateStatusResponse,
  UpSellData,
  UpSellDetail,
  UpSellFollowUp,
  UpSellFollowUpPayload,
  UpSellFollowUpResultPayload,
  UpSellFollowUpSummary,
  UpSellListResponse,
  UpSellPackageInterestedPayload,
  UpSellStatusPayload,
} from './model'

export const UpSellService = (client: AxiosInstance) => {
  return {
    async getUpSellList(opt: PaginationOpt): Promise<UpSellListResponse> {
      const { data } = await wrapApiCall(() =>
        client.get<{
          data: Record<string, unknown>[]
          pagination: Record<string, unknown>
          followUpSummary?: UpSellFollowUpSummary
        }>(`/upsells`, { params: { ...opt } })
      )
      return {
        pagination: deserialize(data?.pagination, PageInfo),
        data:
          data?.data?.map((item: Record<string, unknown>) => deserialize(item, UpSellData)) || [],
        followUpSummary: data?.followUpSummary,
      }
    },
    async getUpSellById(id: string | number): Promise<UpSellDetail> {
      const { data } = await wrapApiCall(() =>
        client.get<Record<string, unknown>>(`/upsells/${id}`)
      )
      return deserialize(data, UpSellDetail)
    },
    async createUpSell(payload: CreateUpSellPayload): Promise<void> {
      await wrapApiCall(() => client.post('/upsells', payload))
    },
    async updateUpSellInterestPackage(
      id: string | number,
      payload: UpSellPackageInterestedPayload
    ): Promise<void> {
      await wrapApiCall(() => client.patch(`/upsells/${id}/package-interest`, payload))
    },
    async updateUpSellNote(id: string | number, note: string): Promise<void> {
      await wrapApiCall(() => client.patch(`/upsells/${id}/note`, { note }))
    },
    async updateUpSellStatus(
      id: string | number,
      payload: UpSellStatusPayload
    ): Promise<UpdateStatusResponse> {
      const { data } = await wrapApiCall(() =>
        client.patch<{ success: boolean }>(`/upsells/${id}/status`, payload)
      )
      return { success: data.success, toStatus: payload.status }
    },
    async getUpSellFollowUpById(id: string | number): Promise<UpSellFollowUp[]> {
      const { data } = await wrapApiCall(() =>
        client.get<Record<string, unknown>[]>(`/upsells/${id}/follow-ups`)
      )
      return data.map((item) => deserialize(item, UpSellFollowUp)) || []
    },
    async createFollowUpResult(
      id: string | number,
      followUp: UpSellFollowUpPayload
    ): Promise<void> {
      await wrapApiCall(() => client.post(`/upsells/${id}/follow-ups/`, followUp))
    },
    async saveFollowUpResult(
      id: string | number,
      followUpID: string,
      payload: UpSellFollowUpResultPayload
    ): Promise<void> {
      await wrapApiCall(() =>
        client.patch(`/upsells/${id}/follow-ups/${followUpID}/result`, payload)
      )
    },
  }
}
